module.exports = __webpack_public_path__ + "img/react.6c85118f.png";